import React from 'react';



export const MobileSupport = ({ height="52px", width="36px",padding="12px",style=''})=> (
<svg className="icon_mobile_outline" role="presentation" aria-label="" padding={padding} viewBox="0 0 26 21" version="1.1" xmlns="http://www.w3.org/2000/svg">
<g id="Symbols" stroke="none" strokeWidth="1" fill="rgb(97, 56, 245)" fillRule="evenodd">
<path d="M14.31,4.48A1.48,1.48,0,0,1,15.79,6V18a1.48,1.48,0,0,1-1.48,1.48H9.73A1.48,1.48,0,0,1,8.25,18V6A1.48,1.48,0,0,1,9.73,4.48h4.58m0-1.48H9.73a3,3,0,0,0-3,3V18a3,3,0,0,0,3,3h4.58a3,3,0,0,0,3-3V6a3,3,0,0,0-3-3ZM12,16.5a.75.75,0,1,0,.75.75A.76.76,0,0,0,12,16.5ZM13.75,6h-3.5V7h3.5Z"/>
</g>

</svg>
);
